@let step = currentStep();
<div class="flex flex-col" [class.md:h-[89vh]]="step === 0" *transloco="let t">
  <bgo-process-navbar
    [activeStep]="step"
    [steps]="[
      {text: t('createJobRequest.steps2.step1'), icon: pencilIcon},
      {text: t('createJobRequest.steps2.step2'), icon: contactIcon},
      {text: t('createJobRequest.steps2.step3'), icon: sendIcon},
    ]"
    [showStepper]="showStepper()"
    [agencyLogo]="agency?.logo"
    (closed)="jobRequestService.askConfirmationToCloseProcess()"
  >
  </bgo-process-navbar>
  <div [class.h-layout]="step !== 0" class="mt-xs h-layout w-full md:mt-2xl">
    <router-outlet (activate)="onRouteActivated($event)" bgoBroadcastActivateEvents></router-outlet>
  </div>
</div>
